/** Dashboard screen (tenant/dashboard.html). */
export const dashboard = {
  title: "Dashboard",
  greeting: {
    morning: "Good morning, {{name}}",
    afternoon: "Good afternoon, {{name}}",
    evening: "Good evening, {{name}}",
  },
  subtitleAgentLead: "Here's how the",
  subtitleAgentTail: "did {{period}}.",
  subtitleAll: "Here's how your assistants did {{period}}.",
  period: {
    "7d": "this week",
    "30d": "in the last 30 days",
    "90d": "in the last 90 days",
  },
  range: {
    label: "Time period",
  },
  vsPrevious: {
    "7d": "vs last week",
    "30d": "vs previous 30 days",
    "90d": "vs previous 90 days",
  },
  testInPlayground: "Test in Playground",
  shareLink: "Share chat link",
  loadError: "The dashboard couldn't load.",
  loadErrorBody: "Your data is safe. Check your connection and try again.",
  checklist: {
    title: "Finish setting up your assistant",
    progress: "Setup {{done}} of {{total}}",
    progressLabel: "Setup progress",
    dismiss: "Dismiss setup checklist",
    dismissed: "Setup checklist hidden. You can find these steps in each section.",
    steps: {
      create_agent: "Create your assistant",
      add_knowledge: "Add your documents",
      test_agent: "Test in the playground",
      install_channel: "Install on your website",
      invite_team: "Invite your team",
      go_live: "Go live",
    },
    done: "Done",
  },
  kpi: {
    conversations: "Conversations",
    resolution: "AI resolution rate",
    firstResponse: "First response",
    handedToStaff: "Handed to staff",
    leads: "Leads captured",
    satisfaction: "Satisfaction",
    p95: "p95 {{value}}",
    ratings_one: "from {{count}} rating",
    ratings_other: "from {{count}} ratings",
    noRatings: "No ratings yet",
    pts: "{{value}} pts",
    noComparison: "No earlier data to compare",
    seconds: "{{value}}s",
    outOf: "/5",
  },
  chart: {
    title: "Conversations per day",
    range: "{{start}} – {{end}} · all channels",
    resolvedByAi: "Resolved by AI",
    handedToStaff: "Handed to staff",
    emptyTitle: "No conversations in this period",
    emptyBody: "Once visitors start chatting, you'll see daily volume here.",
  },
  topics: {
    title: "What people ask about",
    details: "Details",
    emptyTitle: "Topics appear after a few conversations",
    emptyBody: "We group questions by topic so you can see what matters most.",
    languages: "Languages",
    languageNames: {
      en: "English",
      fil: "Filipino",
      tl: "Filipino",
      taglish: "Taglish",
      ceb: "Cebuano",
      pam: "Kapampangan",
      other: "Other",
    },
    share: "{{label}}: {{pct}}",
  },
  recent: {
    title: "Recent conversations",
    openInbox: "Open inbox",
    colVisitor: "Visitor",
    colChannel: "Channel",
    colQuestion: "First question",
    colStatus: "Status",
    colWhen: "When",
    noQuestion: "No question yet",
    emptyTitle: "No conversations yet",
    emptyBody: "Share your chat link or install the widget to start answering questions.",
    status: {
      resolved: "Resolved",
      needs_staff: "Needs staff",
      lead_captured: "Lead captured",
      open: "Open",
      closed: "Closed",
    },
  },
  channels: {
    widget: "Widget",
    webapp: "Web app",
    mobile: "Mobile app",
    messenger: "Messenger",
    email: "Email",
    api: "API",
    playground: "Playground",
  },
  gaps: {
    title: "Top knowledge gaps",
    seeAll: "See all {{count}}",
    asked_one: "Asked {{count}} time",
    asked_other: "Asked {{count}} times",
    answer: "Answer",
    answerLabel: "Answer: {{question}}",
    reasons: {
      no_source: "no source found",
      low_confidence: "low confidence",
      outdated_source: "outdated source",
      conflicting_sources: "conflicting sources",
    },
    emptyTitle: "No open gaps",
    emptyBody: "Your assistant found an answer for every question.",
  },
  knowledge: {
    title: "Knowledge base health",
    manage: "Manage",
    sources: "Sources",
    chunks: "Chunks",
    lastSync: "Last sync",
    never: "Never",
    flaggedBody: "needs attention: {{reason}}",
    flaggedFallback: "check this source for better answers.",
    emptyTitle: "No documents yet",
    emptyBody: "Add your documents so the assistant can answer from them.",
    addSources: "Add sources",
  },
  share: {
    title: "Share your assistant",
    description: "Anyone with this link can chat with {{agent}}.",
    urlLabel: "Public chat link",
    copy: "Copy link",
    copied: "Link copied",
    copyFailed: "Couldn't copy. Select the link and copy it manually.",
    customDomain: "Custom domain verified. Visitors can chat without signing in; signed-in audiences see their private answers.",
    defaultDomain: "Visitors can chat without signing in. Add your own domain in Settings → Domains.",
    openWebApp: "Open web app",
    previewWidget: "Preview widget",
    unavailableTitle: "The web app isn't switched on",
    unavailableBody: "Turn on the web app channel to get a shareable chat link.",
    openChannels: "Open Channels",
    loadError: "We couldn't load the chat link.",
  },
  noAgentsTitle: "Create your first assistant",
  noAgentsBody: "Your dashboard fills up once an assistant starts answering questions.",
  createAgent: "Create assistant",
} as const;
